module.exports = __webpack_public_path__ + "assets/media/SVIP.5b340b25.mp3";